// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { ApplicationFileWithRelationsSchema } from './ApplicationFileRelationsSchema'
import type { ApplicationFileWithRelations } from './ApplicationFileRelationsSchema'
import { OpenApiSchema } from './OpenApiSchema';

/////////////////////////////////////////
// OPEN API RELATION SCHEMA
/////////////////////////////////////////

export type OpenApiRelations = {
  application: ApplicationWithRelations;
  applicationFile: ApplicationFileWithRelations;
};

export type OpenApiWithRelations = z.infer<typeof OpenApiSchema> & OpenApiRelations

export const OpenApiWithRelationsSchema: z.ZodType<OpenApiWithRelations> = OpenApiSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
  applicationFile: z.lazy(() => ApplicationFileWithRelationsSchema),
}))